(function () {
	angular
		.module('trackeye')
		.factory('Permissions', _PermissionsFactory);

	_PermissionsFactory.$inject = ['C4ApiService'];

	function _PermissionsFactory(api) {
		function Permissions(data) {
			this.permissions = [];
			if (data)
				this.permissions = data;

		}

		Permissions.prototype.canCreate = function () {
			return this.has('create');
		};

		Permissions.prototype.canRead = function () {
			return this.has('read');
		};

		Permissions.prototype.canUpdate = function () {
			return this.has('update');
		};

		Permissions.prototype.canDelete = function () {
			return this.has('delete');
		};

		Permissions.prototype.canList = function () {
			return this.has('list');
		};

		Permissions.prototype.canShare = function () {
			return this.has('share');
		};

		Permissions.prototype.isFull = function () {
			return (
				this.has('create') &&
				this.has('update') &&
				this.has('delete') &&
				this.has('read') &&
				this.has('list')
			);
		};

		Permissions.prototype.isReadonly = function () {
			return (
				!this.isFull() &&
				this.has('read') &&
				this.has('list')
			);
		};
		/**
		 * Assert if this permission instance has a given type
		 *
		 * @param {string} type
		 * @returns {boolean}
		 */
		Permissions.prototype.has = function (type) {
			return !!this.permissions.filter(function (perm) {
				return (perm.name == type.toLowerCase());
			}).length;
		};

		/**
		 * Get an array of permissions by name
		 * @param {Array} names
		 * @returns {Array}
		 */
		Permissions.prototype.get = function (names) {
			return this.permissions.filter(function (perm) {
				return (names.indexOf(perm.name) >= 0);
			}).map(function (perm) {
				return {
					id: perm.id,
					type: perm.type,
					name: perm.name
				};
			});
		};

		Permissions.prototype.set = function (data) {
			this.permissions = data;
		};

		Permissions.prototype.save = function (href) {
			return api.forward('POST', href, this.permissions);
		};

		Permissions.prototype.fetch = function (href) {
			var self = this;
			return api.forward('GET', href).then(function (resp) {
				self.set(resp.data);
			}, angular.noop());
		};

		return Permissions;
	}
})();